import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardSpacer from "@saleor/components/CardSpacer";
import CardTitle from "@saleor/components/CardTitle";
import { ControlledCheckbox } from "@saleor/components/ControlledCheckbox";
// import Grid from "@saleor/components/Grid";
import { ProductErrorFragment } from "@saleor/fragments/types/ProductErrorFragment";
import { getFormErrors, getProductErrorMessage } from "@saleor/utils/errors";
// import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import React from "react";
import { useIntl } from "react-intl";

interface CollectionPromptProps {
  data: {
    promptText: string;
    promptBackgroundColor: string;
    promptTextColor: string;
    promptArrowColor: string;
    promptLink: string;
    showPrompt: boolean;
  };
  disabled: boolean;
  errors: ProductErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
}

const CollectionPrompt = ({
  data,
  disabled,
  errors,
  onChange
}: CollectionPromptProps) => {
  const intl = useIntl();

  const formErrors = getFormErrors(["promptText", "promptLink"], errors);

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Product Activity Label",
          description: "Activity Label header"
        })}
      />
      <CardContent>
        <ControlledCheckbox
          checked={data.showPrompt}
          label={intl.formatMessage({
            defaultMessage: "Show Activity Label",
            description: "Show Activity Label, switch button"
          })}
          name={"showPrompt" as keyof FormData}
          onChange={onChange}
        />
        {data.showPrompt && (
          // <Grid variant="uniform">
          <>
            <TextField
              disabled={disabled}
              error={!!formErrors.promptText}
              helperText={getProductErrorMessage(formErrors.promptText, intl)}
              name={"promptText" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Activity Label Text",
                description: "Activity Label Text"
              })}
              value={data.promptText}
              fullWidth
            />
            <CardSpacer />
            <TextField
              disabled={disabled}
              error={!!formErrors.promptLink}
              helperText={getProductErrorMessage(formErrors.promptLink, intl)}
              name={"promptLink" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Activity Link Url",
                description: "Activity Link Url"
              })}
              value={data.promptLink}
              fullWidth
            />
            <CardSpacer />
            <TextField
              disabled={disabled}
              name={"promptBackgroundColor" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Activity Background Color",
                description: "Activity Background Color"
              })}
              value={data.promptBackgroundColor}
              fullWidth
            />
            <CardSpacer />
            <TextField
              disabled={disabled}
              name={"promptTextColor" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Activity Text Color",
                description: "Activity Text Color"
              })}
              value={data.promptTextColor}
              fullWidth
            />
            <CardSpacer />
            <TextField
              disabled={disabled}
              name={"promptArrowColor" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Activity Arrow Color",
                description: "Activity Arrow Color"
              })}
              value={data.promptArrowColor}
              fullWidth
            />
            {/* </Grid> */}
          </>
        )}
      </CardContent>
    </Card>
  );
};
export default CollectionPrompt;
